export enum TransportType {
    None = 0,
    Bus = 1,
    Water = 2
}
